import { render, staticRenderFns } from "./IdentityTypeIcon.vue?vue&type=template&id=798a6e9c&scoped=true&"
import script from "./IdentityTypeIcon.vue?vue&type=script&lang=js&"
export * from "./IdentityTypeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798a6e9c",
  null
  
)

export default component.exports